import { useEffect, useState } from "react";
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useDispatch, useSelector } from "react-redux";
import { updateSection } from "../../../store/Profiles/profilesSlice";
import RowTableFinancial from "../Tables/Row/RowTableFinancial";

const StepFinancialResources = ({ onBack, onNext }) => {
    const dispatch = useDispatch();
    const storedData = useSelector(state => state.profiles.FinancialResources);
    const { t } = useTranslation();
    const [selectedFinancialData, setSelectedFinancialData] = useState(null);

    useEffect(() => {
        setSelectedFinancialData(() => ({
            ...storedData
        }));
    }, [storedData]);

    const handleNextStep = async () => {
        await handleSaveData(); // 🔹 Espera que termine antes de seguir
        onNext();
    };

    const handleSaveData = async () => {
      dispatch(updateSection({ section: "FinancialResources", data: { FinancialResources:selectedFinancialData } }));
    }

      
    const handleChange = async(field, value) => {
        setSelectedFinancialData((prevData) => ({
            ...prevData,
            [field]: value
        }));
    };

    const updateTableFinancial = async ({fieldV, financialData}) => {
        await handleChange(fieldV, financialData); // 🔹 Espera que termine antes de seguir
    };

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {t("Profiles.FinancialResources.FinancialResources")}
            </Typography> 
            <Typography variant="h6" gutterBottom>
                {t("Profiles.FinancialResources.Income")}
            </Typography> 

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t("Profiles.FinancialResources.ClientIncome")}</TableCell>
                            <TableCell>{t("Profiles.FinancialResources.Status(please)")}</TableCell>
                            <TableCell>{t("Profiles.FinancialResources.NeedHelpApplying")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {[
                            "Employment",
                            "SSD",
                            "SSI",
                            "FoodStamps",
                            "TANF",
                            "Unemployment",
                            "VABenefits",
                            "Other"
                        ].map((key, index) => (
                            <RowTableFinancial 
                                key={index}
                                fieldV={ key } 
                                index={index + 1} 
                                Translation={`Profiles.FinancialResources.${key}`} 
                                updateTableFinancial={ updateTableFinancial } 
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Botones */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Button startIcon={<ArrowBackIcon />} onClick={onBack} variant="outlined">
                    {t("common.back")}
                </Button>
                <Button endIcon={<ArrowForwardIcon />} onClick={handleNextStep} variant="contained" color="primary">
                    {t("common.next")}
                </Button>
            </Box>
        </>
    );
};

export default StepFinancialResources;
